import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '../../context/AuthContext';
import { useFieldLayout } from '../../hooks/useMedia';
import { ToolFundCatalog } from '../../modules/ToolFundDashboard/components/ToolFundCatalog';
import { ToolCatalogPhone } from '../../modules/ToolFundDashboard/phone/ToolCatalogPhone';

export const Route = createFileRoute('/toolFundCatalog/')({
  component: RouteComponent,
  head: () => {
    return {
      meta: [{ title: 'Tool Fund Catalog' }],
    };
  },
});

function RouteComponent() {
  const { user } = useAuth();
  const isFieldLayout = useFieldLayout();
  const isCatalogAdmin = user.permissionGroups.some((perm) => perm.name === 'ToolFundCatalogAdmin');
  if (isFieldLayout) return <ToolCatalogPhone enableManagement={isCatalogAdmin} />;
  return <ToolFundCatalog enableManagement={isCatalogAdmin} />;
}
